/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';
import { parseServerDateTime, formatServerDate } from '@/util/MomentUtils';

export default async function SearchAWPackages(parameters) {
  const response = await $.soap({
    body: {
      SearchAwPackages: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageID: parameters.awPackageId,
        CommandName: parameters.commandName,
        TypeID: parameters.typeID,
        StatusID: parameters.statusID,
        DateCreatedStart: parameters.dateCreatedStart,
        DateCreatedEnd: parameters.dateCreatedEnd,
        POPStartDateStart: parameters?.popStartDateStart,
        POPStartDateEnd: parameters?.popStartDateEnd,
        RegionGroupID: parameters.regionGroupID
      }
    },
    blueprintArrays: ['SearchAwPackagesResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      awPackages: [
        '$..old.rowset.row',
        {
          awPackageId: '$.AWPackageID',
          assignedCRS: '$.AssignedCRS',
          assignedEPC: '$.AssignedEPC',
          orderType: '$.FormName',
          awPackageStatus: '$.AWPackageStatus',
          deviceCount: '$.DeviceCount',
          createdOn: '$.CreatedOn',
          regionGroupId: '$.RegionGroupID',
          regionGroup: '$.RegionGroup',
          popStartDate: '$.POPDate'
        }
      ]
    }
  });
  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  const awPackageResults = response.awPackages;
  for (const awPackage of awPackageResults) {
    awPackage.createdOn = formatServerDate(parseServerDateTime(awPackage.createdOn));
  }
  return response;
}
